var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenPositionsDecoration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 37,
    viewBox: "0 0 28 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.81939e-06 22.9184C6.48369e-06 30.5129 6.15609 36.6695 13.75 36.6695C21.3439 36.6695 27.5 30.5129 27.5 22.9184C27.5 15.3239 21.3439 5.38182e-07 13.75 1.20206e-06C6.15609 1.86594e-06 5.15509e-06 15.3239 5.81939e-06 22.9184Z",
    fill: "#F8F8FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenPositionsDecoration);
export default __webpack_public_path__ + "static/media/open-positions-decoration.b13977c7631020ece38f60faf7b3d816.svg";
export { ForwardRef as ReactComponent };